export default "__VITE_ASSET__CsDdDQLo__"